import React from 'react';
import { Users, RefreshCw } from 'lucide-react';
import { useMemberStore } from '../../stores/memberStore';

export function AdminHeader() {
  const { loadMembers, isLoading } = useMemberStore();

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-blue-100 rounded-lg">
            <Users className="w-6 h-6 text-blue-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">会員管理</h1>
        </div>
        
        <button
          onClick={() => loadMembers()}
          disabled={isLoading}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors disabled:opacity-50"
        >
          <RefreshCw className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
          <span>最新の情報に更新</span>
        </button>
      </div>
      <p className="text-gray-600">
        登録されている会員の一覧と管理を行うことができます。
      </p>
    </div>
  );
}